<template>
  <BContainer fluid="lg">
    <BRow>
      <BCol cols="12" lg="6" class="text-center">
        <picture>
          <source
            srcset="https://cdn.vexels.com/img/design-web-animation.png?fmt=webp&w=300"
            type="image/webp"
            media="(max-width: 992px)"
          />
          <source
            srcset="https://cdn.vexels.com/img/design-web-animation.png?fmt=webp"
            type="image/webp"
          />
          <source srcset="https://cdn.vexels.com/img/design-web-animation.png" type="image/png" />
          <img
            class="img-fluid"
            src="https://cdn.vexels.com/img/design-web-animation.png"
            :alt="$t('home.pre-home.welcomeVexels.webDesignImageAlt')"
            height="525"
            width="446"
            loading="lazy"
          />
        </picture>
      </BCol>

      <BCol cols="12" lg="6" class="d-flex align-items-center">
        <BRow cols="1" class="w-100">
          <BCol>
            <h2 class="welcome-title">{{ $t('home.pre-home.welcomeVexels.title') }}</h2>
          </BCol>
          <BCol class="welcome-subtitle">
            {{ $t('home.pre-home.welcomeVexels.subtitle') }}
          </BCol>
          <BCol class="button">
            <Button color="blue" :to="$trailingSlash(localePath('new-vexels'))">
              {{ $t('home.pre-home.welcomeVexels.button') }}
            </Button>
          </BCol>
        </BRow>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script>
import { BContainer, BCol, BRow } from 'bootstrap-vue';
import Button from 'UI/Button';

export default {
  components: {
    BContainer,
    BCol,
    BRow,
    Button
  }
};
</script>

<style lang="scss" scoped>
.welcome-subtitle {
  font-size: 18px;
  margin: 30px 0px;
  @include lg {
    font-size: 15px;
    margin: 15px 0px;
  }
}
.welcome-title {
  font-size: 51px;
  line-height: 51px;
  font-weight: 400;
  margin: 0;
  @include lg {
    font-size: 39px;
  }
}
</style>
